import { useTranslation } from 'react-i18next';

import type { IIndustry } from '../types';

export const useEmailSubjectLineGeneratorIndustries = (): IIndustry[] => {
  const { t } = useTranslation();
  return [
    {
      industry: 'beauty',
      campaignTypes: [
        {
          type: 'productLaunch',
          prompt: t('organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_prompt'),
        },
        {
          type: 'productPromotion',
          prompt: t('organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_prompt'),
        },
      ],
    },
    {
      industry: 'fashion',
      campaignTypes: [
        {
          type: 'productLaunch',
          prompt: t('organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_prompt'),
        },
        {
          type: 'productPromotion',
          prompt: t('organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_prompt'),
        },
      ],
    },
    {
      industry: 'homeGarden',
      campaignTypes: [
        {
          type: 'productUpdate',
          prompt: t('organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_prompt'),
        },
        {
          type: 'storewideSale',
          prompt: t('organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_prompt'),
        },
      ],
    },
    {
      industry: 'cpg',
      campaignTypes: [
        {
          type: 'productLaunch',
          prompt: t('organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_prompt'),
        },
        {
          type: 'storewideSale',
          prompt: t('organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_prompt'),
        },
      ],
    },
    {
      industry: 'restaurantWellness',
      campaignTypes: [
        {
          type: 'announcement',
          prompt: t('organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_prompt'),
        },
        {
          type: 'storewideSale',
          prompt: t('organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_prompt'),
        },
      ],
    },
  ];
};
